import { render, staticRenderFns } from "./RegionDraggable.vue?vue&type=template&id=70b318ba&"
import script from "./RegionDraggable.vue?vue&type=script&lang=js&"
export * from "./RegionDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports